import { authFetch } from "utils";

export const getTenant = (dealID) =>
  authFetch(`${apiUrl}${version}/deals/${dealID}/tenants`, {
    method: "GET",
  });

export const saveTenant = (dealID, tenant) => {
  if (tenant.id) {
    return authFetch(`${apiUrl}${version}/deals/${dealID}/tenants/${tenant.id}`, {
      method: "PATCH",
      json: { tenant },
    });
  }

  return authFetch(`${apiUrl}${version}/deals/${dealID}/tenants`, {
    method: "POST",
    json: { tenant },
  });
};
